import React, { useState } from 'react';
import HomePage from './components/HomePage';
import EditorWorkspace from './components/EditorWorkspace';

function App() {
  const [currentView, setCurrentView] = useState<'home' | 'editor'>('home');

  const handleStartEditing = () => {
    setCurrentView('editor');
  };

  const handleBackToHome = () => {
    setCurrentView('home');
  };

  return (
    <div className="min-h-screen bg-black text-white">
      {currentView === 'home' ? (
        <HomePage onStartEditing={handleStartEditing} />
      ) : (
        <EditorWorkspace onBackToHome={handleBackToHome} />
      )}
    </div>
  );
}

export default App;